import ContentAccordion from './ContentAccordion'
export { ContentAccordion }
export default ContentAccordion
